<template>
  <div class="counterList" v-if="coverageIteration.COV_ESTIMATED_END_DATE">   
     <span class="intime" :class="{'late':time>coverageIteration.COV_ESTIMATED_END_DATE}">{{ [time,coverageIteration.COV_ESTIMATED_END_DATE] | formatDuree($i18n,true)}}</span>
  </div>
</template>

<script lang="ts">
import coverageIteration from '@/api/admin/coverageIteration'
import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  name: 'CoveragEndIn' ,
  props:{
    coverageIteration:{
        type: AloDbCoverageIteration
      }
  }
})
export default class CoveragEndIn extends Vue {
    
  coverageIteration!:AloDbCoverageIteration  
  time = new Date()    
  timerID = -1

  /*Cycle de vie*/
  created() {     
    this.timerID = setInterval(this.updateTime, 1000);                 
  }

  beforeDestroy() {
    clearInterval(this.timerID)
  }

  

  updateTime() {
    this.time = new Date();
  }


}
</script>

<style scope>
  .counter {  
    font-size: 16px;          
    font-weight: bold;      
  }
  .intime{
    color:#3d833d;
  }  
  .late{
    color:#c71a1a;
  }
  .counterList {  
    font-size: 10px;          
    
  }
</style>